import React from "react";
import { RequirementTypesData } from "../../api/models/requirement-types";
import { FormControl, MenuItem, Select, SelectChangeEvent, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

interface RequirementsComponentProps {
  requirement: RequirementTypesData | null;
  requirementIndex: number;
  value: any;
  setValue: (value: any) => void;
}

const RequirementsComponent = ({
  requirement,
  requirementIndex,
  value,
  setValue,
}: RequirementsComponentProps) => {
  const onChangeStringValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    const currentValues = [...value];
    const existingValue = currentValues[requirementIndex] || {};
    currentValues[requirementIndex] = {
      ...existingValue,
      data: {
        requirement_type: requirement?.id,
        value: event.target.value,
      },
    };
    setValue(currentValues);
  };

  const onChangeSelectorValue = (event: SelectChangeEvent<string>) => {
    const currentValues = [...value];
    const existingValue = currentValues[requirementIndex] || {};
    currentValues[requirementIndex] = {
      ...existingValue,
      data: {
        requirement_type: requirement?.id,
        value: event.target.value,
      },
    };
    setValue(currentValues);
  };

  const selectorOptions = requirement?.selector_data ?? [];

  return (
    <div className="w-100">
      {requirement?.data_type === "string" && (
        <div className="w-100">
          <p className="t-nowrap body-text-xs mb-3">
            {requirement?.name}{" "}
            {requirement?.required ? "*" : ""}
          </p>
          <TextField
            fullWidth
            value={value[requirementIndex]?.data?.value || ""}
            size="small"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              onChangeStringValue(event);
            }}
          />
        </div>
      )}
      {requirement?.data_type === "date" && (
        <div className="w-100">
          <p className="t-nowrap body-text-xs mb-3">
            {requirement?.name} {requirement?.required ? "*" : ""}
          </p>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={value[requirementIndex]?.data?.value || null}
              onChange={(newValue) => {
                const currentValues = [...value];
                const existingValue = currentValues[requirementIndex] || {};
                currentValues[requirementIndex] = {
                  ...existingValue,
                  data: {
                    requirement_type: requirement?.id,
                    value: newValue,
                  },
                };
                setValue(currentValues);
              }}
              slotProps={{
                textField: { size: "small", fullWidth: true },
                openPickerButton: {
                  size: "small",
                },
              }}
              format="DD/MM/YYYY"
            />
          </LocalizationProvider>
        </div>
      )}
      {requirement?.data_type === "selector" && (
        <div className="w-100">
          <p className="t-nowrap body-text-xs mb-3">
            {requirement?.name}{" "}
            {requirement?.required ? "*" : ""}
          </p>
          <FormControl fullWidth size="small">
            <Select
              value={value[requirementIndex]?.data?.value ?? ""}
              onChange={onChangeSelectorValue}
              displayEmpty
            >
              <MenuItem value="">
                <em>—</em>
              </MenuItem>
              {selectorOptions.map((option, index) => (
                <MenuItem
                  key={`${option}-${index}`}
                  value={option}
                >
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      )}
    </div>
  );
};

export default RequirementsComponent;
